import { useState } from 'react'
import { ButtonType, showError } from '../../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, SelectionHeaderContainer } from '../../../../../../components'
import { FamiliaIndicadores, FormatoExportacao } from '../../core/_models'
import {
  exportarIndicadoresOperacionais,
  exportarIndicadoresPerformance,
  exportarIndicadoresQualidade,
} from '../../core/_requests'
import { baixarBlob } from '../../core/download'
import { useParametrosIndicadores } from '../../core/QueryRequestProvider'

/** Uma função de exportação por família; a moldura diz qual aba está na tela. */
const exportadorPorFamilia = {
  operacional: exportarIndicadoresOperacionais,
  qualidade: exportarIndicadoresQualidade,
  performance: exportarIndicadoresPerformance,
}

type Props = {
  /** Família exibida no momento do clique — o arquivo baixado é sempre o da aba visível. */
  familia: FamiliaIndicadores
}

/**
 * Exportação nos dois formatos do contrato, sempre com o filtro do momento do
 * clique (lido do hook de parâmetros, não de um estado paralelo) e sempre na
 * rota da família exibida. A rota devolve bytes com `Content-Disposition`,
 * então o consumo é `responseType: 'blob'`.
 */
export const IndicadoresExportacao = ({ familia }: Props) => {
  const { t } = useT()
  const { parametros } = useParametrosIndicadores()

  const [exportando, setExportando] = useState<FormatoExportacao | null>(null)

  const exportar = async (formato: FormatoExportacao) => {
    if (!parametros) return

    setExportando(formato)

    try {
      const arquivo = await exportadorPorFamilia[familia](parametros, formato)
      baixarBlob(arquivo.blob, arquivo.nomeArquivo)
    } catch (error) {
      showError(error)
    } finally {
      setExportando(null)
    }
  }

  const desabilitado = !parametros || exportando !== null

  return (
    <SelectionHeaderContainer className='mt-3 gap-2'>
      <Button
        type={ButtonType.Button}
        className='btn-primary'
        size='btn-sm'
        disabled={desabilitado}
        onClick={() => exportar('csv')}
        title={t('indicadores.exportacao.csv')}
      >
        {exportando === 'csv'
          ? t('indicadores.exportacao.exportando')
          : t('indicadores.exportacao.csv')}
      </Button>
      <Button
        type={ButtonType.Button}
        className='btn-primary'
        size='btn-sm'
        disabled={desabilitado}
        onClick={() => exportar('json')}
        title={t('indicadores.exportacao.json')}
      >
        {exportando === 'json'
          ? t('indicadores.exportacao.exportando')
          : t('indicadores.exportacao.json')}
      </Button>
    </SelectionHeaderContainer>
  )
}
